import React from 'react';
import { Button } from './ui/button';
import { ProfileMenu } from './ProfileMenu';
import { User, UserIcon } from 'lucide-react';

interface MainMenuProps {
  user: User;
  onStartChat: () => void;
  onLogout: () => void;
  onEditProfile?: () => void;
  onDeleteData?: () => void;
}

export function MainMenu({ user, onStartChat, onLogout, onEditProfile, onDeleteData }: MainMenuProps) {
  return (
    <div className="mobile-screen flex items-center justify-center mobile-content p-6 bg-background">
      <div className="w-full max-w-md space-y-8">
        {/* Profile Menu */}
        <div className="flex justify-end">
          <ProfileMenu 
            onEditProfile={onEditProfile} 
            onLogout={onLogout}
            onDeleteData={onDeleteData || (() => {})}
          />
        </div>

        {/* Welcome Section */}
        <div className="text-center space-y-6">
          <div className="space-y-3">
            <h1 className="title-primary">Welcome, {user.name || 'william'}</h1>
            <p className="text-contemplative text-center max-w-sm mx-auto">
              Chat with your Future Self
            </p>
          </div>
        </div>

        {/* Primary Action */}
        <div className="container-sanctuary p-8 text-center space-y-6">
          <div className="space-y-2">
            <div className="w-16 h-16 mx-auto rounded-full bg-muted flex items-center justify-center mb-4">
              <UserIcon className="w-8 h-8 text-muted-foreground" />
            </div>
            <h2 className="title-section">Start Chat</h2>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Begin a conversation with a possible version of your future self. Share your thoughts, ask questions, and gain insights from someone who has lived the life you're building.
            </p>
          </div>
          
          <Button
            onClick={onStartChat}
            className="w-full h-12 button-sanctuary"
            size="lg"
          >
            Start Chat
          </Button>
        </div>

        {/* Secondary Option */}
        <div className="text-center">
          <p className="text-xs text-muted-foreground">
            Your conversations are private and stored only on your device.
          </p>
        </div>
      </div>
    </div>
  );
}